$(document).ready(function () {
  $(document).off('click').on('click', '.add-to-cart-button', function (e) {
  	e.preventDefault();
    let variant_id = $(this).data('variant'), variant_size = $(this).data('variant-size')
    console.log('Button product variant:', variant_id);
    let index = $('.add-to-cart-button').index(this);
    
    $('.add-to-cart-button').eq(index).find('.process-spinner').remove();
    
    if (variant_size <= 1) {
    	  let formData = {
             'items': [{
              'id': variant_id,
              'quantity': 1
              }]
            };
    
   
    
        $(this).append(`<div class="process-spinner"></div>`)


        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => {
         console.log('Response:', response.status);

          if (response.status != 422) {
            returnResponse(index, 'success', response.status);
            let cart_count = parseInt($(".cart-count-bubble span").eq(0).text());
            $(".cart-count-bubble span").eq(0).text(cart_count+1);
            $(".cart-count-bubble").show();
          } else{
            returnResponse(index, 'error', response.status);
          }


         // location.reload();

           return response.json();
        })
        .catch((error) => {
            returnResponse(index, 'error');
          console.error('Error:', error);
        });
    } else{
      
     window.location.href = $(this).attr('href')
      
    }
      
  })
  
  function returnResponse(index, type, status) {
    console.log('Response type:', type);
     let current_span_text = $('.add-to-cart-button').eq(index).find('span').text();
    let response_msg = type === 'success' ? 'Product added to cart' : 'Error adding product to cart';
    
     $('.add-to-cart-button').eq(index).find('.process-spinner').remove();
    $('.add-to-cart-button').eq(index).find('span').text(status == 422 ? 'Product is sold out' : response_msg);
    
    
    setTimeout(() => {
       $('.add-to-cart-button').eq(index).find('span').text(current_span_text);        
    }, 2500) 
  }
})